import { useTranslation } from "@emisgroup/acp-application-intl";
import { END_AFTER, END_BY } from "../Helper/Constants";
import { convertTimeToView } from "../Helper/Script";
import { capitalizeFirstLetter } from "../SchedulingList/ScheduleListTable/helper";
import { IRadioItem } from "../../../Common/UI/RadioButton/Types";
import {
  RecursTypes,
  WeekOfTheMonthTypes,
  WeekOfTheMonthTypesText,
} from "./Types";

/**
 * Generates recurrence type dropdown values
 */
export const getRecursTypes = [
  { value: RecursTypes.Daily, text: capitalizeFirstLetter(RecursTypes.Daily) },
  { value: RecursTypes.Weekly, text: capitalizeFirstLetter(RecursTypes.Weekly) },
  { value: RecursTypes.Monthly, text: capitalizeFirstLetter(RecursTypes.Monthly) },
  { value: RecursTypes.Quarterly, text: capitalizeFirstLetter(RecursTypes.Quarterly) },
  { value: RecursTypes.Yearly, text: capitalizeFirstLetter(RecursTypes.Yearly) },
];

/**
 * Generates times from 00:00 to 23:00
 */
const getHours = (): string[] => {
  const hrs: string[] = [];
  for (let i = 0; i < 48; i++) {
    // Seperating the entries as 00.00, 00.30 of 30 mins intervals
    let n = i % 2 === 0 ? i / 2 + ".00" : (i + 1) / 2 - 1 + ".30";
    if (Number(n) < 10) // Zero-left padding if the 'n' is less than 10
      n = "0" + n;
    hrs.push(n.replace(".", ":"));
  }
  return hrs;
};

/**
 * Generates months from january to december
 */
const getMonths = (): string[] => {
  return Array.from({ length: 12 }, (_item: string, i: number) => {
    return new Date(0, i).toLocaleString("en-UK", { month: "long" });
  });
};

/**
 * Generates days from monday to sunday
 */
export const getWeekDays = (): string[] => {
  const baseDate = new Date(Date.UTC(2017, 0, 2));
  const weekDays: string[] = [];
  for (let i = 0; i < 7; i++) {
    weekDays.push(baseDate.toLocaleDateString("en-UK", { weekday: "long" }));
    baseDate.setDate(baseDate.getDate() + 1);
  }
  return weekDays;
};


/**
 * Generates time dropdown values
 */
export const getTimeValues = getHours().map((hours: string) => {
  return { value: hours, text: hours };
});

// Get the current time to be populated in dropdown selected value
export const getCurrentRecurrenceTime = (time: string): string => {
  const formattedTime = time.length === 5 ? time : convertTimeToView(time);
  const value = getTimeValues.filter((x: any) => x.value === formattedTime);
  return value[0].text;
};

/**
 * Generates week of the month dropdown values
 */
export const getWeekOfTheMonthTypes = [
  { value: String(WeekOfTheMonthTypes.First), text: WeekOfTheMonthTypesText[WeekOfTheMonthTypes.First] },
  { value: String(WeekOfTheMonthTypes.Second), text: WeekOfTheMonthTypesText[WeekOfTheMonthTypes.Second] },
  { value: String(WeekOfTheMonthTypes.Third), text: WeekOfTheMonthTypesText[WeekOfTheMonthTypes.Third] },
  { value: String(WeekOfTheMonthTypes.Fourth), text: WeekOfTheMonthTypesText[WeekOfTheMonthTypes.Fourth] }
];

/**
 * Generates days of the week dropdown values
 */
export const getDaysOfTheWeek = getWeekDays().map((days: string, index: number) => {
  return { value: String(index), text: days };
});

/**
 * Generates months of the year dropdown values
 */
export const getMonthsOfTheYear = getMonths().map((months: string, index: number) => {
  return { value: index + 1, text: months };
});

export function EndDateRadioOptions(disabled: boolean): IRadioItem[] {
  const { t: translate } = useTranslation();

  const options: IRadioItem[] = [
    {
      id: "endBy",
      text: translate("Scheduling.Heading.EndBy"),
      value: END_BY,
      disabled: disabled
    },
    {
      id: "endAfter",
      text: translate("Scheduling.Heading.EndAfter"),
      value: END_AFTER,
      disabled: disabled
    },
  ];
  return options;

}

export const getDayRadioOptions = (disabled: boolean): IRadioItem[] => {
  return [{
    id: "day",
    text: "Day",
    value: "1",
    disabled: disabled
  },
  {
    id: "the",
    text: "The",
    value: "2",
    disabled: disabled
  }];
};

export const getQuarterlyRadioOptions = (disabled: boolean): IRadioItem[] => {
  return [{
    id: "1st Month",
    text: "1st Month",
    value: "1",
    disabled: disabled
  },
  {
    id: "2nd Month",
    text: "2nd Month",
    value: "2",
    disabled: disabled
  },
  {
    id: "3rd Month",
    text: "3rd Month",
    value: "3",
    disabled: disabled
  }];
};
